import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { TerminalNewTask } from '../classes/terminal-new-runs';
import { TerminalRunUpdateTimePayload } from '../classes/terminal-run-update-time-payload';
import { TerminalTask } from '../classes/terminal-task';
import { ConfigurationService } from './configuration.service';
import { LoggerService } from './logger.service';
import { ToastService } from './toast.service';

const TASK_PATH = '/task';
const TERMINAL_PATH = `${TASK_PATH}/terminal`;

@Injectable({
  providedIn: 'root'
})
export class TerminalRunsService {
  constructor(
    private http: HttpClient,
    private logger: LoggerService,
    readonly configService: ConfigurationService,
    private toastService: ToastService
  ) {}

  terminalTask(payload: TerminalTask): Observable<any> {
    return this.configService.getHostApi().pipe(
      switchMap((hostApi: string) =>
        this.http.put<any>(`${hostApi}${TERMINAL_PATH}/${payload.taskName}`, payload).pipe(
          catchError((err: HttpErrorResponse) => {
            this.handleError(err, 'Terminal Task Failed');
            throw new Error(`Terminal task failed with status : ${err.status}`);
          })
        )
      )
    );
  }

  buildTask(payload: TerminalNewTask): Observable<any> {
    return this.configService.getHostApi().pipe(
      switchMap((hostApi: string) =>
        this.http.post(`${hostApi}${TASK_PATH}`, payload, {
          observe: 'response',
          responseType: 'text'
        })
      ),
      catchError((err: HttpErrorResponse) => {
        this.handleError(err, 'Add Task Failed');
        throw new Error(`Add task failed with status : ${err.status}`);
      })
    );
  }

  assignTask(payload: any): Observable<any> {
    return this.configService.getHostApi().pipe(
      switchMap((hostApi: string) =>
        this.http.put<any>(`${hostApi}${TASK_PATH}/${payload.taskIds[0]}`, payload).pipe(
          catchError((err: HttpErrorResponse) => {
            this.handleError(err, 'Assign Terminal Task Failed');
            throw new Error(`Assign Terminal task failed with status : ${err.status}`);
          })
        )
      )
    );
  }

  private handleError(error: HttpErrorResponse, message: string): Observable<never> {
    this.toastService.show('HTTP Error Occurred!', { classname: 'bg-danger text-light', delay: 8000 });
    if (error.status === 0) {
      this.logger.error(`${message}:`, error.error);
    } else {
      this.logger.error(`${message}: ${error.status}, body was: ${error.error}`);
    }
    return throwError(error);
  }


  terminalTaskTimeUpdate(payload: TerminalRunUpdateTimePayload): Observable<any> {
    const headers = new HttpHeaders().set("Content-type", "application/json; charset=utf-8");
    return this.configService.getHostApi().pipe(
      switchMap((hostApi: string) =>
        this.http.put<any>(`${hostApi}${TERMINAL_PATH}/${payload.taskName}`, payload, { "headers":headers, observe: 'response' }).pipe(
          catchError((err: HttpErrorResponse) => {
            this.handleError(err, 'Terminal Task Time Update Failed');
            throw new Error(`Terminal task time update failed with status : ${err.status}`);
          })
        )
      )
    );
  }
}
